import { RecursivePartial } from '@fintronners/react-utils/types/types';
import FinTronConfig from '@fintronners/react-config/src/Config/FinTronConfig';

export const alightConfig: RecursivePartial<typeof FinTronConfig> = {
  selfDirected: {
    trades: {
      maxNotionalValue: 2500000,
      maxMutualFundNotionalValue: 2500000,
      maxOrderQuantity: 50000,
    },
  },
};
